"use strict";

angular
  .module("libraryModule", ["ngKomondorMediaLibrary", "ngKomondorResourceView"])

  .factory("Asset", [
    "DS",
    "$state",
    function (DS, $state) {
      return DS.defineResource({
        name: "Asset",
        endpoint: "assets",
        defaultValues: {
          action_id: 0,
          folder_id: 0,
        },
        methods: {
          goInto: function goInto() {
            if (this.type === "folder") {
              $state.go("admin.media", {
                folder_id: this.id,
                offset: null,
                name: null,
              });
            } else {
              $state.go("admin.media.preview", { id: this.id });
            }
          },
        },
      });
    },
  ])

  .run(["File", function (File) {}]) // jshint ignore:line
  .factory("File", [
    "DS",
    function (DS) {
      return DS.defineResource({
        name: "File",
        endpoint: "files",
      });
    },
  ]);
